module.exports = __webpack_public_path__ + "img/IMG_2248_L_Wood_MockedUp.d774fef6.jpg";